"use client"
import { Star } from "lucide-react"
import { cn } from "@/lib/utils"

interface StarRatingProps {
  rating: number
  max?: number
  size?: number
  interactive?: boolean
  onChange?: (rating: number) => void
  className?: string
}

export function StarRating({
  rating,
  max = 5,
  size = 16,
  interactive = false,
  onChange,
  className,
}: StarRatingProps) {
  return (
    <div className={cn("flex items-center gap-0.5", className)}>
      {Array.from({ length: max }).map((_, i) => {
        const filled = i < Math.round(rating)
        return (
          <Star
            key={i}
            size={size}
            fill={filled ? "currentColor" : "none"}
            className={cn(
              filled ? "star-filled" : "star-empty",
              interactive && "cursor-pointer hover:star-filled transition-colors"
            )}
            onClick={interactive && onChange ? () => onChange(i + 1) : undefined}
          />
        )
      })}
    </div>
  )
}

export function RatingDisplay({
  rating,
  count,
  size = 14,
}: {
  rating: number
  count?: number
  size?: number
}) {
  if (rating === 0) {
    return (
      <span className="text-xs text-[var(--muted-foreground)]">No reviews yet</span>
    )
  }
  return (
    <div className="flex items-center gap-1.5">
      <StarRating rating={rating} size={size} />
      <span className="text-sm font-semibold text-[var(--foreground)]">
        {rating.toFixed(1)}
      </span>
      {count !== undefined && (
        <span className="text-xs text-[var(--muted-foreground)]">({count})</span>
      )}
    </div>
  )
}
